import ServiceAuth from "src/services/auth/authToken"
import ManageStorage from "src/shared/global/manageStorage"

const authGuestAction = async () => {
    const res = await ServiceAuth.authUserGuest({
        username: process.env.REACT_APP_USER_GUEST
    })

    ManageStorage.setItemStorage("token", res.data.accessToken);
}

export default authGuestAction
